var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DraggableColumns',{attrs:{"settings":_vm.settings,"activeColumn":_vm.activeSupports,"masterColumn":_vm.masterSupports,"loading":_vm.loading},on:{"save":_vm.saveSupports}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }